module.exports = __webpack_public_path__ + "img/video_cover.16253543.jpg";